import { useState, useEffect } from 'react';

export default function useControlType() {
  const [controlType, setControlType] = useState(null);

  useEffect(() => {
    // Detección universal: Si el giroscopio emite eventos, usamos DeviceControls
    // Si no hay eventos en 2 segundos, fallback a OrbitControls
    // Esto cubre todos los casos: Android sin gyro, iOS sin permiso, etc.

    let gyroscopeDetected = false;
    let detectionTimeout;

    const handleOrientationEvent = (event) => {
      // Confirmar que el giroscopio emite datos reales
      if (event.alpha !== null || event.beta !== null || event.gamma !== null) {
        gyroscopeDetected = true;
        setControlType('gyroscope');
        cleanup();
      }
    };

    const cleanup = () => {
      window.removeEventListener('deviceorientation', handleOrientationEvent);
      window.removeEventListener('deviceorientationabsolute', handleOrientationEvent);
      if (detectionTimeout) clearTimeout(detectionTimeout);
    };

    // Escuchar eventos de orientación
    window.addEventListener('deviceorientation', handleOrientationEvent);
    window.addEventListener('deviceorientationabsolute', handleOrientationEvent);

    // Timeout de 2 segundos: Si no detectó eventos, usar OrbitControls como fallback
    detectionTimeout = setTimeout(() => {
      if (!gyroscopeDetected) {
        setControlType('orbit');
        cleanup();
      }
    }, 2000);

    return cleanup;
  }, []);

  return controlType;
}
